class StripeConnectSuccessCtrl {
  constructor($state, $stateParams, organizations, userPreferencesService) {
    const vm = this;

    const selectedVenueId = userPreferencesService.getStripeVenue();
    const selectedOrganizationId = userPreferencesService.getDefaultOrganization();

    // console.log('selectedVenueId', selectedVenueId);
    // console.log('selectedOrganizationId', selectedOrganizationId);

    if (!selectedVenueId || !selectedOrganizationId) {
      vm.error = 'We ran into issues connecting your Stripe account.';
    }

    // console.log('selectedVenueId', selectedVenueId);
    // console.log('stripe_user_id', $stateParams.stripe_user_id);
    // console.log('error', $stateParams.error);

    $state.go('app.organization.settings.venue.billing', {
      organizationId: selectedOrganizationId,
      venueId: selectedVenueId,
      stripeUserId: $stateParams.stripe_user_id
    });

    return null;
  }
}

StripeConnectSuccessCtrl.$inject = [
  '$state',
  '$stateParams',
  'organizations',
  'userPreferencesService'
];

export default StripeConnectSuccessCtrl;



// WEBPACK FOOTER //
// ./src/components/stripeConnectSuccess/stripeConnectSuccessCtrl.js